import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import "primereact/resources/primereact.min.css";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { Api } from '../../../services/api';

const Log = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [projectType, setProjectType] = useState([]);
    const [searchProjectType, setSearchProjectType] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [globalFilter, setGlobalFilter] = useState('');

    const [selectedRowData, setSelectedRowData] = useState(null);

    const toast = useRef(null);
    const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] = useState(false);

    const [selectedProduct, setSelectedProduct] = useState(null);


    const closeModal = () => {
        setIsModalOpen(false);
        setIsDeleteConfirmationModalOpen(false);
        setSelectedRowData(null);
    };



    useEffect(() => {
        console.log('Fetching projects...xx');
        getProjectType();
    }, []);

    const getProjectType = (project) => {

        const token = localStorage.getItem('authToken');
        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };

        axios.get(Api.API_BASE_URL + 'all-history-track', { headers })
            .then((response) => {

                var data = response.data.result;
                setProjectType(data);
                setSearchProjectType(data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
                setIsLoading(false);
            });


    };

    const fetchRowDetails = (rowData) => {
        const token = localStorage.getItem('authToken');
        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };
        console.log(rowData._id);
        
    
        axios.get(`${Api.API_BASE_URL}/history-track/${rowData._id}`, { headers })
            .then((response) => {
                // Assuming the response contains the data you want to display
                const data = response.data.result;
                setSelectedRowData(data); // Update the selected row data with the fetched data
            })
            .catch((error) => {
                console.error('Error fetching row details:', error);
                // Optionally, you can show a toast notification for the error
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch row details', life: 3000 });
            });
    };

    const searchrole = (searchValue) => {
        console.log('searchValue', searchValue);

        // Reset the projectType to the original searchProjectType
        const searchResult = searchProjectType.filter((item) => {
            const lowerCaseSearchValue = searchValue.toLowerCase();
            return (
                item.created_at.toLowerCase().includes(lowerCaseSearchValue) ||
                item.created_by.toLowerCase().includes(lowerCaseSearchValue) ||
                item.module.toLowerCase().includes(lowerCaseSearchValue)
            );
        });

        setProjectType(searchResult);
        console.log(searchResult);
    };

    const header = (
        <div className="flex flex-wrap  align-items-center justify-content-between m-2 ">
            <h4 > </h4>
            <div>
                <span className="p-input-icon-left ">
                    <InputText className="input-field" type="search" onChange={(e) => searchrole(e.target.value)} placeholder="Search..." />
                </span>

            </div>
        </div>
    );

    const onRowSelect = (e) => {
        const rowData = e.data;
        console.log('rowData', rowData);
        
        setSelectedRowData(rowData); // Set the selected row data
        setIsModalOpen(true);
        fetchRowDetails(rowData);
    };

    const crmFieldMapping = [
        { label: "First Name", key: "first_name" },
        { label: "Last Name", key: "last_name" },
        { label: "Email", key: "email" },
        { label: "Phone Number", key: "phone_number" },
        { label: "Street Number", key: "street_number" },
        { label: "Street Name", key: "street_name" },
        { label: "City", key: "city" },
        { label: "Contact Date", key: "contact_date" },
        { label: "Lead Source", key: "lead_source" },
        { label: "Lead Assignee", key: "assignee" },
        { label: "Who Referred You", key: "who_referred_you" },
        { label: "Project Type", key: "project_type" },
        { label: "Project Value", key: "project_value" },
        { label: "Status", key: "new_status" },

        { label: "First Meeting Date", key: "site_visit_date" },
        { label: "CE Sent out", key: "ce_sent_out" },
        { label: "FSA Signed Development Date", key: "development_date" },
        { label: "FSA Signed Construction Date", key: "fsa_date" },
        { label: "Contract Date", key: "contract_date" },
        { label: "Construction Start Date", key: "construction_start_date" },
        { label: "Construction Completion Date", key: "completion_date" },
        { label: "Project Description", key: "project_desc" },
        { label: "Client Information", key: "cilentInformation" }
    ];

    const projectCRMFieldMapping = [
        { label: "Project", key: "project_name" },
        { label: "Internal Job", key: "internal_job" },
        { label: "Hours Per Day", key: "hours_per_day" },
        { label: "Original Expected GP", key: "orig_expected_gp" },
        { label: "Margin %", key: "project_cost_per" },
        { label: "Fixed Price", key: "fixedPrice" },
        { label: "Contract Amount", key: "contract_amount" },
        { label: "Actual To Date", key: "actual_to_date" },
        { label: "Actuals Minus Fees", key: "actual_fees" },
        { label: "Fixed Months", key: "fixed_month" },
        // { label: "Development Manager", key: "development_manager" },
        // { label: "Project Manager", key: "project_manager" },
        // { label: "Job Autospy", key: "project_manager" },
        // { label: "Superintendent", key: "sp_manager" },
        // { label: "Pre con Manager", key: "pre_con_manager" },
        // { label: "Interior Design", key: "interior_design" },
        // { label: "Warranty", key: "project_manager" }
    ];

    const incomeStatementFieldMapping = [
        { label: "Month", key: "month" },
        { label: "Year", key: "year" },
        { label: "POC", key: "poc" },
        { label: "Total Income", key: "totalIncome" },
        { label: "Total Other Income", key: "totalOtherIncome" },
        { label: "COGS-Total", key: "cogsTotal" },
        { label: "Uncategorized", key: "uncategorized" },
        { label: "Marketing & Sales", key: "MarketingSales" },
        { label: "Admin Wages Fixed Ticks", key: "AdminWagesFixedTick" },
        { label: "VP Construction Operations", key: "vpConstructionOperations" },
        { label: "Admin Wages", key: "AdminWages" },
        { label: "Facilities", key: "Facilities" },
        { label: "Office", key: "Office" },
        { label: "General & Admin", key: "GeneralAdmin" },
        { label: "Custom Home and Renovation", key: "custome_home_and_renovation" },
        { label: "Commercial and Multi Family", key: "commercial_and_multi_family" },
        { label: "Total Accounts Receivable", key: "TotalAccountsReceievable" },
        { label: "Total Other Current Assets", key: "TotalOtherCurrentAssets" },
        { label: "Materials For Future Jobs", key: "MaterialsForFutureJobs" },
        { label: "Due From To Shareholder", key: "DueFromToShareholder" },
        { label: "WIP Costs In Excess Of Billings", key: "WipCostsInExcessOfBillings" },
        { label: "Total Fixed Assets", key: "TotalFixedAssets" },
        { label: "Total Other Assets", key: "TotalOtherAssets" },
        { label: "Total Current Assets", key: "TotalCurrentAssets" },
        { label: "Total Current Liabilities", key: "TotalCurrentLiabilities" },
        { label: "Total Long Term Liabilities", key: "TotalLongTermLiabilities" },
        { label: "Total Equity", key: "TotalEquity" },
        { label: "Corp Tax Paid", key: "CorpTaxPaid" },
        { label: "Construction Financing", key: "ConstructionFinancing" },
        { label: "To Balance Cash", key: "ToBalanceCash" },
        { label: "Number of Management Staff", key: "NumberOfManagementStaff" },
        { label: "Number of Employees", key: "NumberOfEmployees" },
        { label: "Number of PM's", key: "NumberOfPms" }
    ];

    const excludedFields = [
        "AdminWagesFixedTick",
        "NumberOfManagementStaff",
        "NumberOfEmployees",
        "NumberOfPms",
        "month",
        "year",
    ];


    const formatValue = (key, value) => {
        // console.log('value====>' , value);

        // Add $ prefix to all fields except the excluded ones
        if (!excludedFields.includes(key) && value != ' ') {
            return `$${value}`;
        }
        return value;
    };

    const formatValuec = (key, value) => {
        const dollarFormattedFields = [
            "orig_expected_gp",
            "fixedPrice",
            "contract_amount",
            "actual_to_date",
            "actual_fees",
            "project_value",
            "month",
            "year",
            
            "AdminWagesFixedTick",
            "NumberOfManagementStaff",
            "NumberOfEmployees",
            "NumberOfPms"
        ];
    
        if (dollarFormattedFields.includes(key) && value !== ' ') {
            return `$${parseFloat(value).toFixed(2)}`;
        }
    
        return value;
    };
    




    return (
        <>

            <div className="pagee-container mt-2">
                <Toast ref={toast} />
                <ConfirmDialog />
                <div className="pagination-datable-height">
                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (

                        <DataTable
                            value={projectType}
                            paginator
                            rows={14}
                            key="id"
                            tableStyle={{ minWidth: '50rem', }}
                            selectionMode="single"
                            selection={selectedProduct}
                            onRowSelect={onRowSelect}
                            onSelectionChange={(e) => setSelectedProduct(e.value)}
                            header={header}
                            globalFilter={globalFilter}
                            scrollHeight="flex"

                        >
                            <Column key="created_at" field="created_at" header="Timestamp" />
                            <Column key="created_by" field="created_by" header="Name:" />
                            <Column key="module" field="module" header="Module" />
                            <Column key="type" field="type" header="Action" />
                        </DataTable>
                    )}
                </div>
            </div>
            {/* ---------------------------------------------------------------*/}
            <Dialog
                header="Data Comparison"
                visible={isModalOpen}
                onHide={closeModal}
                style={{ width: '60vw', borderRadius: '8px', padding: '1rem' }}
            >
                {/* CRM Module */}
                {selectedRowData && selectedRowData.module === "CRM" && (
                    <div className="flex flex-column">
                        <table className="table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: '200px', padding: '8px', border: '1px solid #ddd' }}>Field</th>
                                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>Old Data</th>
                                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>New Data</th>
                                </tr>
                            </thead>
                            <tbody>
                                {crmFieldMapping.map((field, index) => {
                                    const oldValue = selectedRowData.old_data[field.key] || ' ';
                                    const newValue = selectedRowData.new_data[field.key] || ' ';
                                    const rowStyle = {
                                        backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff', // Alternating colors
                                        ...(oldValue !== newValue ? { backgroundColor: '#ffcccc' } : {}) // Highlight if different
                                    };
                                    return (
                                        <tr key={index} style={rowStyle}>
                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{field.label}</td>
                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{formatValuec(field.key, oldValue)}</td>
                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{formatValuec(field.key, newValue)}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* Project(CRM) Module */}
                {selectedRowData && selectedRowData.module === "Project(CRM)" && (
                    <div className="flex flex-column">
                        <table className="table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: '200px', padding: '8px', border: '1px solid #ddd' }}>Field</th>
                                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>Old Data</th>
                                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>New Data</th>
                                </tr>
                            </thead>
                            <tbody>
                                {projectCRMFieldMapping.map((field, index) => {
                                    const oldValue = selectedRowData.old_data[field.key] || ' ';
                                    const newValue = selectedRowData.new_data[field.key] || ' ';
                                    const rowStyle = {
                                        backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff', // Alternating colors
                                        ...(oldValue !== newValue ? { backgroundColor: '#ffcccc' } : {}) // Highlight if different
                                    };
                                    return (
                                        <tr key={index} style={rowStyle}>
                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{field.label}</td>
                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{formatValuec(field.key, oldValue)}</td>
                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{formatValuec(field.key, newValue)}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* Income Statement Module */}
                {selectedRowData && selectedRowData.module === 'Income-statement' && (
                    <div className="flex flex-column">
                        <table className="table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr>
                                    <th style={{  width: '200px',padding: '8px', border: '1px solid #ddd' }}>Field</th>
                                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>Old Data</th>
                                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>New Data</th>
                                </tr>
                            </thead>
                            <tbody>
                                {incomeStatementFieldMapping.map((field, index) => {
                                    const oldValue = selectedRowData.old_data[field.key] || ' ';
                                    const newValue = selectedRowData.new_data[field.key] || ' ';
                                    const rowStyle = {
                                        backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff',
                                        ...(oldValue !== newValue ? { backgroundColor: '#ffcccc' } : {}) 
                                    };
                                    return (
                                        <tr key={index} style={rowStyle}>
                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{field.label}</td>
                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{formatValue(field.key, oldValue)}</td>
                                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{formatValue(field.key, newValue)}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </Dialog>




        </>
    )
}

export default Log